import React, { useContext, useEffect } from 'react';
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import CommonContext from '../../hooks/CommonContext';
import toast from 'react-hot-toast';
import Select from 'react-dropdown-select';
import Autocomplete from "react-google-autocomplete";
import { IoClose } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { handleGoogleApiLocation, handleInput, handleReset } from 'Actions/commonAction/milleSearchFilterActions';

const HomeFilterForm = () => {
    const { location, enteredInputLocation } = useSelector((state) => state.milleSearchStates);
    const dispatch = useDispatch();

    const filterHeadings = ["dummy", "dummy", "dummy", "dummy", "dummy", "dummy", "dummy", "dummy", "dummy"]
    const {
        setApplyFilterCount, applyFilterResponse,
        specialisationData, sectorData,
        locationData, skillData,
        FilterArray, gettingResponse,
        setapplyFilterResponse,
        setFilteringObject,
        setAnswer, setCurrentPage,
        setSkillData,
        setLocationData,
        setSectorData,
        setSpecialisationData,
        skills, setSkills,
        sectors, setSectors,
        specialization, setSpecialization,
        workplaceType, setWorkplaceType,
        jobTypee, setJobTypee,
        schedule, setSchedule,
        setSortBy,
        skillsSearch, setSkillsSearch,
        sectorSearch, setSectorSearch,
        speciSearch, setSpeciSearch,
        initializeReset,
        isApplyFilterClicked, setIsApplyFilterClicked,
        searchInput, isSearched, setIsMellieSearch,
        professionalMellieSearch, getHomeAll

    } = useContext(CommonContext);

    useEffect(() => {
        setSkills([])
        setSectors([])
        setSpecialization([])
        setWorkplaceType([])
        setJobTypee([])
        setSchedule([])
    }, [])

    const handleWorkplaceType = (e) => {
        if (e.target.checked) {
            setWorkplaceType(prevState => [...prevState, e.target.name])
        }
        else {
            if (!e.target.checked) {
                const removeUnwantedWorkplace = workplaceType.filter((v) => {
                    return v !== e.target.name
                })
                setWorkplaceType(removeUnwantedWorkplace)
            }
        }
    }

    const handleJobType = (e) => {
        if (e.target.checked) {
            setJobTypee(prevState => [...prevState, e.target.name])
        }
        else {
            if (!e.target.checked) {
                const removeUnwantedJobType = jobTypee.filter((v) => {
                    return v !== e.target.name
                })
                setJobTypee(removeUnwantedJobType)
            }
        }
    }

    const handleSchedule = (e) => {
        if (e.target.checked) {
            setSchedule(prevState => [...prevState, e.target.name])
        }
        else {
            if (!e.target.checked) {
                const removeUnwantedSchedule = schedule.filter((v) => {
                    return v !== e.target.name
                })
                setSchedule(removeUnwantedSchedule)
            }
        }
    }

    useEffect(() => {
        var getFilterLength = skills.length + sectors.length + location.length + workplaceType.length + jobTypee.length + schedule.length + specialization.length
        setApplyFilterCount(getFilterLength);

        if (getFilterLength === 0 && gettingResponse) {
            const ChangeSkillDisableFalse = skillData.map((skills) => {
                return { ...skills, disabled: false }
            })
            setSkillData(ChangeSkillDisableFalse)

            const ChangeSectorDisableFalse = sectorData.map((sectors) => {
                return { ...sectors, disabled: false }
            })
            setSectorData(ChangeSectorDisableFalse)

            const ChangeSpeciDisableFalse = specialisationData.map((specilization) => {
                return { ...specilization, disabled: false }
            })
            setSpecialisationData(ChangeSpeciDisableFalse)

            const ChangeLocationDisableFalse = locationData.map((location) => {
                return { ...location, disabled: false }
            })
            setLocationData(ChangeLocationDisableFalse)
        }

    }, [skills, sectors, specialization, location, workplaceType, jobTypee, schedule])

    const initializeFilter = (type) => {
        if (type === "Apply Filter") {
            var getFilterLength = skills.length + sectors.length + location.length + workplaceType.length + jobTypee.length + schedule.length + specialization.length
            setApplyFilterCount(getFilterLength)
            setSortBy("Date Latest")

            if (getFilterLength > 0) {
                setIsApplyFilterClicked(true)
                setAnswer([]);
                setCurrentPage(0);
                setIsMellieSearch(true)

                const locationConvertion = location.map((v) => {
                    const originalVal = v.split(',')
                    const joinOriginalValue = originalVal.join('&&&&&')

                    return joinOriginalValue
                })

                var a = skills.map((v) => v.label)
                var b = sectors.map((v) => v.label)
                var c = specialization.map((v) => v.label)
                var d = locationConvertion

                const object = {
                    skills: a,
                    sector: b,
                    specialisation: c,
                    workplace_type: workplaceType,
                    location: d,
                    job_type: jobTypee,
                    work_schedule: schedule,
                    job_status: ["opened"],
                    plan: ["Basic", "Premium", "Platinum"],
                    search_text: isSearched ? searchInput : ''
                }

                setFilteringObject(object)
                setapplyFilterResponse(true)
                professionalMellieSearch(object)
            } else {
                toast.error('fields are empty');
            }
        } else {
            if (type === "Clear Filter" && !isSearched) {
                getHomeAll()
                setIsMellieSearch(false)
                initializeReset()
                dispatch(handleReset())
                setapplyFilterResponse(true)
                return
            }

            const object = {
                skills: [],
                sector: [],
                specialisation: [],
                workplace_type: [],
                location: [],
                job_type: [],
                work_schedule: [],
                job_status: ["opened"],
                plan: ["Basic", "Premium", "Platinum"],
                search_text: isSearched ? searchInput : ''
            }
            initializeReset()
            dispatch(handleReset())
            setapplyFilterResponse(true)
            setIsMellieSearch(false)
            professionalMellieSearch(object)
        }
    }

    const handleSkills = (skillsValue) => {
        setSkills(skillsValue)

        if (skillsValue.length > 0) {
            const checkIfValueIsOthers = skillsValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = skillData.map((skills) => {
                    return skills.label !== "Others" ? { ...skills, disabled: true } : skills
                })
                setSkillData(ChangeOtherValuesToDisable)
                setSkillsSearch(false)
            } else {
                const ChangeOtherValuesToDisable = skillData.map((skills) => {
                    return skills.label === "Others" ? { ...skills, disabled: true } : skills
                })
                setSkillData(ChangeOtherValuesToDisable)
                setSkillsSearch(true)
            }
        } else {
            const ChangeDisableFalse = skillData.map((skills) => {
                return { ...skills, disabled: false }
            })
            setSkillData(ChangeDisableFalse)
            setSkillsSearch(true)
        }
    }

    const handleSectors = (sectorValue) => {
        setSectors(sectorValue)
        if (sectorValue.length > 0) {
            const checkIfValueIsOthers = sectorValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = sectorData.map((sectors) => {
                    return sectors.label !== "Others" ? { ...sectors, disabled: true } : sectors
                })
                setSectorData(ChangeOtherValuesToDisable)
                setSectorSearch(false)
            } else {
                const ChangeOtherValuesToDisable = sectorData.map((sectors) => {
                    return sectors.label === "Others" ? { ...sectors, disabled: true } : sectors
                })
                setSectorData(ChangeOtherValuesToDisable)
                setSectorSearch(true)
            }
        } else {
            const ChangeDisableFalse = sectorData.map((sectors) => {
                return { ...sectors, disabled: false }
            })
            setSectorData(ChangeDisableFalse)
            setSectorSearch(true)
        }
    }

    const handleSpecilization = (specilizationValue) => {
        setSpecialization(specilizationValue)
        if (specilizationValue.length > 0) {
            const checkIfValueIsOthers = specilizationValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = specialisationData.map((specilization) => {
                    return specilization.label !== "Others" ? { ...specilization, disabled: true } : specilization
                })
                setSpecialisationData(ChangeOtherValuesToDisable)
                setSpeciSearch(false)
            } else {
                const ChangeOtherValuesToDisable = specialisationData.map((specilization) => {
                    return specilization.label === "Others" ? { ...specilization, disabled: true } : specilization
                })
                setSpecialisationData(ChangeOtherValuesToDisable)
                setSpeciSearch(true)
            }
        } else {
            const ChangeDisableFalse = specialisationData.map((specilization) => {
                return { ...specilization, disabled: false }
            })
            setSpecialisationData(ChangeDisableFalse)
            setSpeciSearch(true)
        }
    }

    return (
        <form>

            {
                gettingResponse === false && applyFilterResponse === false ?
                    filterHeadings.map((value, index) => {
                        return <div className="mb-5 placeholder-glow" key={index}>
                            <p className="card-title placeholder col-6 rounded py-3"></p>
                            <h6 className="card-text placeholder col-12 rounded py-2 pt-3"></h6>
                        </div>
                    })
                    :
                    null
            }

            {
                isApplyFilterClicked ?
                    <div className='mb-3'>
                        <Button
                            id="professionalHomeClearDataButton"
                            buttonType={"button"}
                            className={"btn btn-transparent border border-brand-color w-100"}
                            functionOnchange={() => initializeFilter("Clear Filter")}
                            title={"Clear Filter"}
                        />
                    </div>
                    :
                    null
            }

            {
                FilterArray.schedule !== undefined ?
                    <div className="mb-4">
                        <h5 className="job-filter-sub-headings">Schedule</h5>
                        {
                            FilterArray.schedule.length !== 0 ? <>
                                {FilterArray.schedule.map((value, index) => {
                                    return <div className="form-check ms-3" key={index}>
                                        <Input name={value} functionOnchange={handleSchedule} className={"form-check-input"} type={"checkbox"} testId={value} id={`workplace_${value}`} formFieldName={value} formLableFor={`workplace_${value}`} formLableclassName={"form-check-label"} />
                                    </div>
                                })}
                            </>
                                :
                                null
                        }
                    </div>
                    :
                    null
            }

            {
                FilterArray.skill !== undefined ?
                    <div className='mb-4'>
                        <h6 className='fw-bold'>Skills</h6>
                        <Select
                            multi
                            color='#ffa32d'
                            style={{ fontSize: ".9rem" }}
                            className='rounded-1'
                            options={skills.length < 5 ? skillData : []}
                            addPlaceholder={skillsSearch ? "Select up to 5 skills" : ""}
                            onChange={handleSkills}
                            values={skills}
                        />
                    </div>
                    :
                    null
            }

            {
                FilterArray.sector !== undefined ?
                    <div className='mb-4'>
                        <h6 className='fw-bold'>Sector</h6>
                        <Select
                            multi
                            color='#ffa32d'
                            style={{ fontSize: ".9rem" }}
                            className='rounded-1'
                            options={sectors.length < 5 ? sectorData : []}
                            addPlaceholder={sectorSearch ? "Select up to 5 sectors" : ""}
                            onChange={handleSectors}
                            values={sectors}
                        />
                    </div>
                    :
                    null
            }

            {
                FilterArray.specialisation !== undefined ?
                    <div className='mb-4'>
                        <h6 className='fw-bold'>Functional Specialization</h6>
                        <Select
                            multi
                            color='#ffa32d'
                            style={{ fontSize: ".9rem" }}
                            className='rounded-1'
                            options={specialization.length < 5 ? specialisationData : []}
                            addPlaceholder={speciSearch ? "Select up to 5 Funct..." : ""}
                            onChange={handleSpecilization}
                            values={specialization}
                        />
                    </div>
                    :
                    null
            }

            {
                FilterArray.workplace_type !== undefined ?
                    <div className="mb-4">
                        <h5 className="job-filter-sub-headings">Workplace Type</h5>
                        {
                            FilterArray.workplace_type.length !== 0 ? <>
                                {FilterArray.workplace_type.map((value, index) => {
                                    return <div className="form-check ms-3" key={index}>
                                        <Input name={value} functionOnchange={handleWorkplaceType} className="form-check-input" type="checkbox" testId={value} id={`workplace_${value}`} formFieldName={value} formLableFor={`workplace_${value}`} formLableclassName={"form-check-label"} />
                                    </div>
                                })}
                            </>
                                :
                                null
                        }
                    </div>
                    :
                    null
            }

            {
                FilterArray.location !== undefined ?
                    <div className='mb-4'>
                        <h6 className='fw-bold'>Location</h6>
                        <div className={location.length ? 'd-flex flex-wrap mb-2' : 'd-none'}>
                            {location.map((v) => (
                                <div className="col-12 py-1 pe-1">
                                    <div className="autocomplete-location-card w-100 d-flex flex-wrap align-items-center">
                                        <div className="col-11">
                                            <p className='w-100 mb-0 text-break'>{v}</p>
                                        </div>
                                        <div className="col-1">
                                            <IoClose className='fs-5 cursorPointer' onClick={() => dispatch(handleGoogleApiLocation({ type: "delete", deletionData: v }))} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <Autocomplete
                            apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                            className='google-places-api'
                            onPlaceSelected={(place) => {
                                if (place) {
                                    dispatch(handleGoogleApiLocation({ type: "push", place: place.address_components }))
                                }
                            }}
                            onChange={(e) => dispatch(handleInput({ field: 'location', value: e.target.value }))}
                            value={enteredInputLocation}
                            disabled={location.length === 5}
                        />
                    </div>
                    :
                    null
            }

            {
                FilterArray.job_type !== undefined ?
                    <div className="mb-4">
                        <h5 className="job-filter-sub-headings">Job Type</h5>
                        {
                            FilterArray.job_type.length !== 0 ? <>
                                {FilterArray.job_type.map((value, index) => {
                                    return <div className="form-check ms-3 overflow-hidden" key={index}>
                                        <Input name={value} functionOnchange={handleJobType} className={"form-check-input reset-jobType "} type={"checkbox"} testId={value} id={`workplace_${value}`} formFieldName={value} formLableFor={`workplace_${value}`} formLableclassName={"form-check-label"} />
                                    </div>
                                })}
                            </>
                                :
                                null
                        }
                    </div>
                    :
                    null
            }



            <div >
                {
                    gettingResponse === false ?
                        <Button buttonType={"button"} className={"btn btn-brand-color w-100 placeholder pointer"} title={"Apply Filter"} />
                        :
                        <Button id="professionalHomeApplyFilterButton" buttonType={"button"} className={"btn btn-brand-color w-100"} title={"Apply Filter"} functionOnchange={() => initializeFilter("Apply Filter")} />
                }
            </div>
        </form>
    )
}

export default HomeFilterForm